import { render, staticRenderFns } from "./refundOrderDetail.vue?vue&type=template&id=04baf553&scoped=true"
import script from "./refundOrderDetail.vue?vue&type=script&lang=js"
export * from "./refundOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./refundOrderDetail.vue?vue&type=style&index=0&id=04baf553&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04baf553",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chillzon/Documents/projects/crmeb_view/mer_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04baf553')) {
      api.createRecord('04baf553', component.options)
    } else {
      api.reload('04baf553', component.options)
    }
    module.hot.accept("./refundOrderDetail.vue?vue&type=template&id=04baf553&scoped=true", function () {
      api.rerender('04baf553', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/pointsMall/components/refundOrderDetail.vue"
export default component.exports